window.complementarySwiper = window.complementarySwiper || null;
window.recommendationObserver = window.recommendationObserver || null;

function initializeSwiper() {
  const slider = document.querySelector(".complementary-slider-mobile");

  if (!slider) {
    console.warn("Swiper: .complementary-slider-mobile not found, retrying...");
    return;
  }

  if (slider.classList.contains("swiper-initialized")) return;

  if (window.complementarySwiper) {
    window.complementarySwiper.destroy(true, true);
  }

  window.complementarySwiper = new Swiper(".complementary-slider-mobile", {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: { slidesPerView: 1 },
      1024: { slidesPerView: 1 },
    },
  });

  slider.classList.add("swiper-initialized");
}

function observeRecommendations() {
  const targetNode = document.querySelector("product-recommendations");
  if (!targetNode) return;

  if (window.recommendationObserver) {
    window.recommendationObserver.disconnect();
  }

  window.recommendationObserver = new MutationObserver(() => {
    setTimeout(initializeSwiper, 300);
  });

  window.recommendationObserver.observe(targetNode, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", initializeSwiper);

document.addEventListener("shopify:section:load", function (event) {
  if (event.detail.sectionId.includes("product-recommendations")) {
    initializeSwiper();
    observeRecommendations();
  }
});

observeRecommendations();
